interface AccessTokenResponse {
  success: boolean;
  access_token: string;
  token_type: string;
  expires_in: number;
}

export const parseAccessToken = (response: AccessTokenResponse) => {
  return {
    success: response.success,
    accessToken: response.access_token,
    tokenType: response.token_type,
    expiresIn: response.expires_in * 1000,
  };
};

interface UserInfoResponse {
  packageStatusTracking: string;
  subscriber: boolean;
  userId: string;
  email: string;
  success: boolean;
  userStatus: string;
  userPackage: string;
}

export const parseUserInfo = (response: UserInfoResponse) => {
  return {
    packageStatus: response.packageStatusTracking,
    subscriber: response.subscriber,
    userId: response.userId,
    email: response.email,
    success: response.success,
    userStatus: response.userStatus,
    userPackage: response.userPackage,
  };
};
